import archetypesJson from "@/data/archetypes.json";
import pagesJson from "@/data/pages.json";


export default {

	currentPage: state => {
		if (state.pageName) {
			let i = pagesJson.findIndex(p => p.name === state.pageName);
			let p = pagesJson[i];
			Object.assign(p, {
				index: i
			})
			return p;
		}
		return null
	},

	usersList: state => {

		// First get a sorted list of users so everyone sees the same order
		var sortedKeys = Object.keys(state.usersObj).sort();

		// Create an empty array to return
		var list = [];

		// Loop through the users in order
		var key;

		for (var i = 0; i < sortedKeys.length; i++) {

			// Store current key
			key = sortedKeys[i];

			if (state.usersObj[key].connected) {

				// Populate the list array with each user's data
				list.push({
					name: state.usersObj[key].name,
					key: key,
					isController: key == state.controllerKey
				});
			}
		}
		return list;
	},

	isController: state => {
		if (state.user) {
			return state.user.isController
		} else {
			return false
		}
	},

	pageList: state => pagesJson,

	role: state => {
		return state.selectedRole;
	},
	task: state => {
		if (state.side === "adversary") {
			return state.scenario.adversaryTask
		} else if (state.side === "advocate") {
			return state.scenario.advocateTask;
		} else {
			return "";
		}
	},

	selectedArchetypeText: state => {
		let t = "";

		if (state.selectedArchetype) {
			t = state.selectedArchetype.title;
			if (t === "other") {
				t += " (" + state.selectedArchetype.text + ")";
			}
		}

		return t;
	},

	selectedRoleText: state => {
		let t = "";

		if (state.selectedRole) {

			t = state.selectedRole.title;

			if (t === "other") {
				t = state.selectedRole.text;
			}
		}

		return t;
	},

	// VIDEOS
	aftermathVideoSrc: state => {
		if (state.side === "advocate") {
			return {
				webm: "Adv_Endings_Advocate.webm",
				mp4: "Adv_Endings_Advocate.mp4"
			};
		} else if (state.side === "adversary") {
			return {
				webm: "Adv_Endings_Adversary.webm",
				mp4: "Adv_Endings_Adversary.mp4"
			};
		} else {
			return "";
		}
	},

	selectedArchetype: state => {
		// Return a clean version of the archetype
		return {
			index: state.selectedArchetype.index,
			title: state.selectedArchetype.title,
			text: (state.archetypeOtherText) ? state.archetypeOtherText : state.selectedArchetype.text
		}
	},

	selectedRole: state => {
		// Return a clean version of the archetype
		return {
			index: state.selectedRole.index,
			title: state.selectedRole.title,
			text: (state.roleOtherText) ? state.roleOtherText : state.selectedRole.text
		}
	},

	// ARRAYS

	archetypes: state => {
		if (state.side === "adversary") {
			return archetypesJson.adversaryArchetypes;
		} else {
			return archetypesJson.advocateArchetypes;
		}
	},
	hints: state => {
		if (state.side === "adversary") {
			return state.scenario.adversaryHints;
		} else if (state.side === "advocate") {
			return state.scenario.advocateHints;
		} else {
			return [];
		}
	},
	roles: state => {
		if (state.side === "adversary") {
			return state.scenario.adversaryRoles;
		} else if (state.side === "advocate") {
			return state.scenario.advocateRoles;
		} else {
			return [];
		}
	},

	showTactic: state => {
		if (state.side === "adversary") {
			return state.scenario.adversaryTactics.find(function (v) { return v['active'] === true });
		} else if (state.side === "advocate") {
			return state.scenario.advocateTactics.find(function (v) { return v['active'] === true });
		} else {
			return false;
		}
	},


	tactics: state => {
		if (state.side === "adversary") {
			return state.scenario.adversaryTactics;
		} else if (state.side === "advocate") {
			return state.scenario.advocateTactics;
		} else {
			return false;
		}
	}
}